import request from '@/api/request.js'
// 这里面存关于检测方案的请求
//   ------------左边
// 查询检测方案列表
// const requesNew = (data) => {
//   return request({
//     ...data,
//     ...{
//       baseURL: "/dev-info-monitor",
//     },
//   });
// };

export function getPageList(data) {
  return request({
    url: '/info-sentinel-scheme/pageList',
    method: 'post',
    data,
  })
}
export const schemeDataList = (data) => {
  return request({
    url: `/info-sentinel-scheme-data/pageList`,
    method: 'post',
    data
  });
};
export const getDataById = (id) => {
  return request({
    url: `/info-sentinel-scheme/getDataById/${id}`,
    method: 'get',
  });
};
export const schemeDataDetail = (data) => {
  return request({
    url: `/info-sentinel-scheme-data/getById`,
    method: 'post',
    data
  });
};
export const getTotal = (data) => {
  return request({
    url: `/info-sentinel-scheme-data/getTotal`,
    method: 'post',
    data
  });
};
export const exportData = (data) => {
  return request({
    url: `/info-sentinel-scheme-data/export`,
    method: 'post',
    data,
    responseType: 'blob'
  });
};
export const batchDel = (data) => {
  return request({
    url: `/info-sentinel-scheme-data/batchDel`,
    method: 'DELETE',
    data
  });
};